import React from 'react';

import css from './Alert.module.scss';

const ICONS = {
  greenCheck: {
    src: '/static/green-check-circle.svg',
    alt: 'Checkmark',
    css: css.greenCheckIcon
  },
  lightbulb: {
    src: '/static/lightbulb.svg',
    alt: 'Lightbulb',
    css: css.lightbulbIcon
  },
  sparkle: {
    src: '/static/sparkle.svg',
    alt: 'sparkle',
    css: css.lightbulbIcon
  },
  error: {
    src: '/static/toastError.svg',
    alt: 'error',
    css: css.lightbulbIcon
  }
};

interface AlertProps {
  heading: string;
  message: string;
  icon?: keyof typeof ICONS;
  color: 'green' | 'yellow' | 'red';
  highlightText?: string;
}

const Alert = ({
  icon,
  heading,
  message,
  color,
  highlightText = ''
}: AlertProps) => {
  return (
    <div
      className={`${css.alert} ${css[`alert--${color}`]}`}
      data-testid="alert"
    >
      {icon && (
        <img
          src={ICONS[icon].src}
          alt={ICONS[icon].alt}
          className={ICONS[icon].css}
        />
      )}

      <div>
        <p data-testid="alert-heading">{heading}</p>
        {highlightText && (
          <span className={css.highlightText}>{`${highlightText} `}</span>
        )}
        <span data-testid="alert-message">{message}</span>
      </div>
    </div>
  );
};

export default Alert;
